var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopRightShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 351,
    viewBox: "0 0 352 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.553 210.295L305.047 91.8005L305.047 339.121C305.047 349.433 317.502 354.589 324.791 347.3L467.824 204.268C476.502 195.589 476.502 181.52 467.824 172.842L186.553 -108.43C175.986 -118.996 158.864 -118.996 148.297 -108.43L8.06273 31.8048C-2.50401 42.3716 -2.50401 59.4936 8.06273 70.0603L148.297 210.295C158.864 220.861 175.986 220.861 186.553 210.295Z",
    fill: "#FFF6CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M318.945 92.3074L318.945 91.1003L318.092 91.9539L200.89 209.156C190.634 219.412 174.015 219.412 163.759 209.156L25.054 70.4508C14.7978 60.1946 14.7978 43.5759 25.054 33.3197L163.759 -105.385C174.015 -115.641 190.634 -115.641 200.89 -105.385L479.093 172.818C487.482 181.207 487.482 194.806 479.093 203.195L337.621 344.667C330.726 351.562 318.945 346.685 318.945 336.93L318.945 92.3074Z",
    stroke: "#6DDFA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightShape);
export default __webpack_public_path__ + "static/media/top-right-shape.d851fa9c7598db55f0d20611c94a9bb7.svg";
export { ForwardRef as ReactComponent };